import APITemplate from '@api/APITemplate'
import { diffTimeMinutes } from '@utils/Format'
import store from '@state/store'
import { MINUTES_TIMEOUT_REQUESTS } from '@constants/Numbers'
import con from '@services/connection'
import { carteiraAdministrada } from '@modules/clients/constants/URL.js'

class APIClientsCarteiraAdministrada extends APITemplate {
  constructor() {
    super()

    this.reqCarregar = null
  }

  async loadData({ forceUpdate = false, idClient } = {}) {
    if (this.reqCarregar) {
      return this.reqCarregar
    }
    if (!forceUpdate) {
      if (
        !diffTimeMinutes(
          store.getters['moduleClients/carteiraAdministradaLastUpdate'],
          MINUTES_TIMEOUT_REQUESTS
        )
      ) {
        return store.getters['moduleClients/carteiraAdministrada']
      }
    }

    if (store.getters['moduleClients/carteiraAdministradaLoading']) {
      return store.getters['moduleClients/carteiraAdministrada']
    }

    store.dispatch('moduleClients/setCarteiraAdministradaLoading', true)

    this.reqCarregar = con.get(carteiraAdministrada.carregar(idClient))
    const r = await this.reqCarregar

    if (r && r.status === 200) {
      store.dispatch('moduleClients/setCarteiraAdministrada', r.value || {})
    } else {
      store.dispatch('moduleClients/setCarteiraAdministrada', {})
    }

    store.dispatch('moduleClients/setCarteiraAdministradaLoading', false)

    this.reqCarregar = null

    return r || {}
  }

  async save({ id, data }) {
    const url = carteiraAdministrada.salvar(id)
    const payload = {
      data: JSON.stringify(data),
    }

    const r = await con.post(url, payload)

    return r || {}
  }

  async edit({ id, data }) {
    const url = carteiraAdministrada.editar(id)
    const payload = {
      data: JSON.stringify(data),
    }

    const r = await con.put(url, payload)

    return r || {}
  }

  async remove({ id, data }) {
    const url = carteiraAdministrada.remover(id)
    const payload = {
      data: JSON.stringify(data),
    }

    const r = await con.delet(url, payload)

    return r || {}
  }
}

const apiClientsCarteiraAdministrada = new APIClientsCarteiraAdministrada()
export { apiClientsCarteiraAdministrada }
